import { gql } from '@apollo/client';

export const ZIP_CODE = gql`
  query vetZipCode {
    me {
      vetProfile {
        id
        zipcode
      }
    }
  }
`;

export const PROFILE = gql`
  query profile {
    me {
      id
      firstName
      lastName
      email
      vetProfile {
        id
        phoneNumber
        address
        zipcode
        state
        city
        profilePic
        petcoUserId
        emailNotifications
        textNotifications
        automaticallyAddRunsToCalendar
        licenses {
          id
          document
          expirationDate
          number
          stateCode
        }
        deaRegistrations {
          id
          document
          expirationDate
          number
          stateCode
        }
        insurances {
          id
          document
          expirationDate
          policyNumber
        }
      }
    }
  }
`;

export const PROFILE_FIRST_ACCESSS = gql`
  query profileFirstAccess {
    me {
      vetProfile {
        id
        firstAccess
      }
    }
  }
`;

export const PROFILE_VERIFIED = gql`
  query profileVerified {
    me {
      vetProfile {
        id
        verifiedInfo
        askForShiftPreferences
        askForNetPromoterScore
      }
    }
  }
`;

export const DVM_CONTRACT_TYPE = gql`
  query dvmContractType {
    me {
      vetProfile {
        id
        contractType
      }
    }
  }
`;

export const BASIC_PROFILE = gql`
  query basicProfile {
    me {
      id
      firstName
      lastName
      vetProfile {
        id
        verifiedInfo
        licenses {
          id
          expirationDate
          number
          stateCode
        }
      }
    }
  }
`;

export const DASHBOARD = gql`
  query dashboard($year: Int!, $status: [String]) {
    me {
      id
      firstName
      lastName
      dateJoined
      vetProfile {
        id
        firstAccess
        availableTokenCount
        clinics(year: $year)
        total(year: $year)
      }
    }
    myUpcomingShifts(first: 1) {
      edges {
        node {
          id
          name
          date
          shiftType
          shiftRequirements
          ... on RunType {
            acceptedBid {
              id
              amount
              history {
                id
                profileType
                created
                amount
              }
            }
          }
          ... on HospitalShiftType {
            acceptedBid {
              id
              amount
              isFullShift
              history {
                id
                profileType
                created
                amount
              }
            }
          }
          ... on ShiftProxyType {
            acceptedBid {
              id
              amount
              isFullShift
              history {
                id
                profileType
                created
                amount
              }
            }
          }
          status
          events {
            id
            date
            date
            startTime
            endTime
            location {
              id
              dispatchDistrict {
                clinicLeaders {
                  name
                  phoneNumber
                }
                hospitalLeaders {
                  name
                  phoneNumber
                }
              }
              phoneNumber
              street1
              code
              name
              latitude
              longitude
              distance
              timezone
            }
          }
        }
      }
    }
    myBids(first: 3, status: $status) {
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          id
          amount
          finalStatus
          isFullShift
          shift {
            id
            name
            date
            shiftType
            shiftRequirements
            events {
              id
              date
              startTime
              endTime
              date
              location {
                id
                distance
                street1
                code
                latitude
                longitude
                timezone
              }
            }
          }
        }
      }
    }
  }
`;

export const LICENSES = gql`
  query licenses {
    me {
      vetProfile {
        id
        licenses {
          id
          document
          expirationDate
          number
          stateCode
        }
      }
    }
  }
`;

export const REGISTRATIONS = gql`
  query licenses {
    me {
      vetProfile {
        id
        deaRegistrations {
          id
          document
          expirationDate
          number
          stateCode
        }
      }
    }
  }
`;

export const INSURANCES = gql`
  query insurances {
    me {
      vetProfile {
        id
        insurances {
          id
          document
          expirationDate
          policyNumber
        }
      }
    }
  }
`;

export const VET_PREFERENCES = gql`
  query vetPreferences {
    me {
      vetProfile {
        preferences {
          preferences
        }
      }
    }
  }
`;

export const CONTACT_REQUEST_PROFILE = gql`
  query contactRequestProfile {
    me {
      email
      vetProfile {
        address
        zipcode
        state
        city
      }
    }
  }
`;

export const REFERRAL_SOURCES = gql`
  query referralSources {
    referralSources{
      id
      name
      hasInput
      isInputRequired
      inputLabel
    }
  }
`;

export const RECOVER_ONBOARDING_VET_PROFILE = gql`
  query onboardingVetProfile($token: String!) {
    onboardingProfile(token: $token) {
      uid
      firstName
      lastName
      email
      phoneNumber
      shouldEmailNotifications
      shouldTextNotifications
      address1
      address2
      state
      city
      zipcode
      referralSource {
        id
        name
        hasInput
        isInputRequired
        inputLabel
      }
      referralCode
      status
    }
  }
`;

export const AVAILABLE_TOKENS = gql`
  query availableTokens {
    me {
      vetProfile {
        id
        availableTokenCount
      }
    }
  }
`;

export const BUY_IT_NOW_TOKENS_INFO = gql`
  query buyItNowTokensInfo {
    buyItNowTokensInfo {
      availableTokens
      expiringTokens
      expirationDate
      transactions {
        id
        transactionType
        date
        tokenAmount
        shift {
          date
          name
        }
      }
    }
  }
`;
